import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';
import logo from './image/logo.svg';
import navBg from './image/Nav_bg.svg';
import button from './image/button.svg';
import { FaYoutube, FaFacebookF, FaInstagram, FaEnvelope } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate('/contact');
  };

  return (
    <header>
      {/* Top Navigation */}
      <nav className="top-nav" style={{ backgroundImage: `url(${navBg})` }}>
        <div className="top-nav-container">
          <div className="logo-button">
            <img src={logo} alt="Logo" className="logo" />
            <h1>Nashabandhi Mandal Maharashtra Rajya</h1>
          </div>
          <div className="social-icons">
            <a href="#"><FaYoutube /></a>
            <a href="https://www.facebook.com/nashabandimandal.maharashtrastate.5?mibextid=ZbWKwL"><FaFacebookF /></a>
            <a href="https://www.instagram.com/nasha_bandi_mandal/?igsh=YnN6NW5lNmNxdGJ2"><FaInstagram /></a>
            <a href="#"><FaEnvelope /></a>
          </div>
        </div>
      </nav>

      {/* Main Navigation */}
      <nav className="navbar" style={{ backgroundImage: `url(${navBg})` }}>
        <div className="nav-container">
          <div className="support-button">
            <img src={button} alt="Support a Cause" className="button-icon" onClick={handleButtonClick}/>
          </div>
          <div className="hamburger" onClick={toggleMenu}>
            <div></div>
            <div></div>
            <div></div>
          </div>
          
          <ul className={`nav-links ${isOpen ? 'active' : ''}`}>
            <li><Link to="/" onClick={toggleMenu}>HOME</Link></li>
            <li><Link to="/contact" onClick={toggleMenu}>CONTACT</Link></li>
            <li><Link to="/awards" onClick={toggleMenu}>AWARDS</Link></li>
            <li><Link to="/gallery" onClick={toggleMenu}>GALLERY</Link></li>
            <li><Link to="/magazine" onClick={toggleMenu}>MAGAZINE</Link></li>
            <li><Link to="/events" onClick={toggleMenu}>EVENTS</Link></li>
            <li><Link to="/program" onClick={toggleMenu}>PROGRAMS</Link></li>
            <li><Link to="/know" onClick={toggleMenu}>KNOW US</Link></li>
          </ul>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
